import { useState, useEffect } from "react";
import axios from "axios";
import { Bell, Check } from "@phosphor-icons/react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { getErrorMessage } from "@/lib/auth";

const API = `${window.location.origin}/api`;

export function StockAlertSettings() {
  const [form, setForm] = useState({ low_stock_kg: 10, expiry_days: 30 });
  const [saving, setSaving] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/settings/stock-alerts`).then((r) => setForm(r.data)).catch(() => {}).finally(() => setLoaded(true));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const r = await axios.put(`${API}/settings/stock-alerts`, { low_stock_kg: Number(form.low_stock_kg), expiry_days: Number(form.expiry_days) });
      setForm(r.data);
      toast.success("Stock alert settings saved");
    } catch (err) { toast.error(getErrorMessage(err)); }
    finally { setSaving(false); }
  };

  return (
    <Card className="p-6 border border-gray-200 bg-white" data-testid="stock-alert-settings">
      <h3 className="text-sm font-semibold text-gray-900 mb-1 flex items-center gap-2">
        <Bell size={16} className="text-red-500" weight="bold" /> Stock Alerts
      </h3>
      <p className="text-xs text-gray-500 mb-4">Shown on the Dashboard and Inventory page. You can also set a custom minimum for any product in Inventory → Min KG.</p>
      <div className="grid grid-cols-2 gap-3 mb-4 max-w-md">
        <div>
          <Label className="text-sm font-medium">Low stock below (KG)</Label>
          <Input type="number" min="0" step="0.5" value={form.low_stock_kg} onChange={(e) => setForm((p) => ({ ...p, low_stock_kg: e.target.value }))} disabled={!loaded} className="h-10 font-mono" data-testid="low-stock-kg-input" />
        </div>
        <div>
          <Label className="text-sm font-medium">Expiring within (days)</Label>
          <Input type="number" min="1" max="365" value={form.expiry_days} onChange={(e) => setForm((p) => ({ ...p, expiry_days: e.target.value }))} disabled={!loaded} className="h-10 font-mono" data-testid="expiry-days-input" />
        </div>
      </div>
      <Button onClick={save} disabled={saving || !loaded} className="bg-indigo-600 hover:bg-indigo-700 text-white" data-testid="save-stock-alerts-btn">
        <Check size={16} className="mr-1" /> {saving ? "Saving..." : "Save Alert Settings"}
      </Button>
    </Card>
  );
}
